import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TranslationsService, UTILS_ICON_ADD } from '@wdx/shared/utils';
import { LayoutAndDefinitionEntry } from '../../../models';

@Component({
    selector: 'wdx-ff-sub-form-header',
    templateUrl: './sub-form-header.component.html',
    standalone: false,
})
export class FormSubFormHeaderComponent {
    private translationsService = inject(TranslationsService);

    @Input() amount!: number;
    @Input() set elementDefinition(value: LayoutAndDefinitionEntry) {
        this.definition = value;
        if (value?.min) {
            this.validationErrorMessage = value.max
                ? this.translationsService.translateTokenisedString(
                      'FORM_VALIDATION_ERROR_MIN_MAX',
                      { min: value.min.toString(), max: value.max.toString() },
                  )
                : this.translationsService.translateTokenisedString(
                      'FORM_VALIDATION_ERROR_MIN',
                      { min: value.min.toString() },
                  );
        }
    }
    @Input() disabled!: boolean;
    @Input() showValidation = false;
    @Input() readonlyMode?: boolean;

    @Output() addToArray = new EventEmitter();

    public validationErrorMessage = '';
    public definition!: LayoutAndDefinitionEntry;

    readonly addIcon = UTILS_ICON_ADD;

    onAddToArrayClicked(): void {
        this.addToArray.emit();
    }
}
